/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { PureComponent } from "react";
import EmptyComponentCss from "./EmptyComponent.css";

class EmptyComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.elementHandle = null;
  }

  render() {
    const { height, width } = this.props;
    const style = {
      width: `${width}px`,
      height: `${height}px`
    };
    return (
      <div
        className={EmptyComponentCss.EmptyComponent}
        ref={handle => {
          this.elementHandle = handle;
        }}
      >
        <div style={style} className={EmptyComponentCss.innerDiv} />
      </div>
    );
  }
}

export { EmptyComponent };
